import axios from 'axios';
import { InsufficientStockResponse } from '../models';

const MINUTES_PER_HOUR = 60;
const HTTP_CONFLICT = 409;
const INSUFFICIENT_STOCK_CODE = 'INSUFFICIENT_STOCK';

export function extractInsufficientStock(error: unknown): InsufficientStockResponse | null {
  if (!axios.isAxiosError(error) || error.response?.status !== HTTP_CONFLICT) return null;
  const data = error.response.data as Partial<InsufficientStockResponse> | undefined;
  if (data?.code !== INSUFFICIENT_STOCK_CODE || !Array.isArray(data.items)) return null;
  return data as InsufficientStockResponse;
}

function pluralize(value: number, singular: string, plural: string) {
  return `${value} ${value === 1 ? singular : plural}`;
}

export function formatReservationDuration(minutes: number): string {
  if (minutes < MINUTES_PER_HOUR) return pluralize(minutes, 'minuto', 'minutos');
  const hours = Math.floor(minutes / MINUTES_PER_HOUR);
  const rest = minutes % MINUTES_PER_HOUR;
  const hoursLabel = pluralize(hours, 'hora', 'horas');
  return rest === 0 ? hoursLabel : `${hoursLabel} e ${pluralize(rest, 'minuto', 'minutos')}`;
}

function isSameLocalDay(a: Date, b: Date) {
  return a.toDateString() === b.toDateString();
}

export function formatReservationDeadline(deadline: Date, now: Date = new Date()): string {
  const time = deadline.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  if (isSameLocalDay(deadline, now)) return time;
  const date = deadline.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  return `${date} às ${time}`;
}

export function parseInstant(iso?: string | null): Date | null {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}
